import { isPast } from "date-fns";

type ContestStatus = "active" | "ended" | "expired" | "inactive";

interface ContestStatusBadgeProps {
  isActive: boolean;
  endedAt: string | null;
  endsAt: string | null;
}

export function getContestStatus(
  isActive: boolean,
  endedAt: string | null,
  endsAt: string | null
): ContestStatus {
  // Manual end takes priority
  if (endedAt) return "ended";
  
  // Check if expired (past ends_at date)
  if (endsAt && isPast(new Date(endsAt))) return "expired";
  
  // Check if inactive
  if (!isActive) return "inactive";
  
  return "active";
}

export function ContestStatusBadge({ isActive, endedAt, endsAt }: ContestStatusBadgeProps) {
  const status = getContestStatus(isActive, endedAt, endsAt);

  const statusConfig: Record<ContestStatus, { label: string; className: string }> = {
    active: {
      label: "Active",
      className: "bg-success/10 text-success",
    },
    ended: {
      label: "Ended",
      className: "bg-destructive/10 text-destructive",
    },
    expired: {
      label: "Expired",
      className: "bg-warning/10 text-warning",
    },
    inactive: {
      label: "Inactive",
      className: "bg-muted text-muted-foreground",
    },
  };

  const config = statusConfig[status];

  return (
    <span className={`px-3 py-1.5 rounded-full text-sm font-medium ${config.className}`}>
      {config.label}
    </span>
  );
}
